import React, { useState, useEffect } from "react";
import { Content } from './styles'
import { Input } from "../Input";
import { api } from "../../services/api";
import { Button } from "../Button";

interface WebhookEvent {
    event: "newMessage" | "qr" | "profilePicture" | "updateConnection" | "jobResponse";
    url: string;
}

export function WebHook() {
    const [newMessageUrl, setNewMessageUrl] = useState("");
    const [qrCodeUrl, setQrCodeUrl] = useState("");
    const [profilePictureUrl, setProfilePictureUrl] = useState("");
    const [updateConnectionUrl, setUpdateConnectionUrl] = useState("");
    const [jobResponseUrl, setJobResponseUrl] = useState("");

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await api.get('/whatsapp/events');
                const data = response.data;

                if (data.length) {
                    data.forEach((event: WebhookEvent) => {
                        switch (event.event) {
                            case "newMessage":
                                setNewMessageUrl(event.url);
                                break;
                            case "qr":
                                setQrCodeUrl(event.url);
                                break;
                            case "profilePicture":
                                setProfilePictureUrl(event.url);
                                break;
                            case "updateConnection":
                                setUpdateConnectionUrl(event.url);
                                break;
                            case "jobResponse":
                                setJobResponseUrl(event.url);
                                break;
                            default:
                                break;
                        }
                    });
                }
                setNewMessageUrl(data.newMessageUrl);
                setQrCodeUrl(data.qrCodeUrl);
                setProfilePictureUrl(data.profilePictureUrl);
                setUpdateConnectionUrl(data.updateConnectionUrl);
            } catch (error) {
                console.error("Erro ao buscar eventos:", error);
            }
        };

        fetchEvents();
    }, []);

    const saveEvents = async () => {
        const eventsData = {
            newMessage: newMessageUrl,
            qr: qrCodeUrl,
            profilePicture: profilePictureUrl,
            updateConnection: updateConnectionUrl,
            jobResponse: jobResponseUrl,
        };

        try {
            await api.put('/whatsapp/events', eventsData);
        } catch (error) {
            console.error("Erro ao salvar eventos:", error);
        }
    };

    return (
        <Content>
            <div className="header-conf">
                <span>WebHook - Eventos</span>
            </div>

            <div className="form-group">
                <span>Nova mensagem (newMessage)</span>
                <p>Esse evento é disparo sempre que o whatsapp recebe um nova mensagem passar para url cadastrada todos os dados da mensagem recebida.</p>
                <Input type="" placeholder="Digite um URL" value={newMessageUrl}
                    onChange={(ev) => setNewMessageUrl(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
                <span>QrCode (qr)</span>
                <p>Esse evento é disparo quando uma nova conexão for iniciada, ele envia um qrcode para url cadastrada.</p>
                <Input type="" placeholder="Digite um URL" value={qrCodeUrl}
                    onChange={(ev) => setQrCodeUrl(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
                <span>Atualização de Foto de Perfil (profilePicture)</span>
                <p>Esse evento é disparo sempre que um contato atualiza sua foto de perfil.</p>
                <Input type="" placeholder="Digite um URL" value={profilePictureUrl}
                    onChange={(ev) => setProfilePictureUrl(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
                <span>Atualização de Conexão (updateConnection)</span>
                <p>Esse evento é disparo sempre que a conexão é atualizada enviado para a URL cadastrada o status da conexão.</p>
                <Input type="" placeholder="Digite um URL" value={updateConnectionUrl}
                    onChange={(ev) => setUpdateConnectionUrl(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
                <span>Resposta de Job (jobResponse)</span>
                <p>Esse evento é disparo sempre que um job é finalizado enviado para a URL cadastrada o status da conexão.</p>
                <Input type="" placeholder="Digite um URL" value={jobResponseUrl}
                    onChange={(ev) => setJobResponseUrl(ev.currentTarget.value)} />
            </div>
            <Button onClick={saveEvents} title="Salvar" className="btn-save" />
        </Content>
    )
}